import EFPicture from 'elem/compCommon/EFPicture';
import PortableDesign from '@elem/SVGIcon/VanlifeRoadtrips/PortableDesign';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import SolarPanel from '@elem/SVGIcon/CostSaving/SolarPanel';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('costsaving');
    const icons: any = [
        {
            icon: <PlugAndPlay />,
            text: t('secC_icon1'),
        },
        {
            icon: <PortableDesign />,
            text: t('secC_icon2'),
        },
        {
            icon: <SolarPanel />,
            text: t('secC_icon3'),
        },
    ];
    return (
        <div id="cost-saving-C" className={`cost-saving-C cost-saving-box ${css['cost-saving-C']}`}>
            <div className="content-box">
                <div className="img-box">
                    <EFPicture
                        src={'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719541959721/Frame%20161269337%20(1).jpg'}
                        srcMobile={'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719542142574/pic%20(1).jpg'}
                        alt={t('secC_title')}
                    />
                </div>
                <div className="text-info">
                    <h2 className="title white">{t('secC_title')}</h2>
                    <p className="desc s">{t('secC_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text li">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
